module.exports = __webpack_public_path__ + "img/img2.891895cf.png";